<template>
  <div>
    <Head :title="title" />
    <div class="mb-8 flex justify-start max-w-full flex-wrap">
      <h1 class="font-bold text-3xl">
        <inertia-link
          class="text-indigo-400 hover:text-indigo-600"
          :href="route('admin.portal-announcements.index')">
          Portal Pengumuman
        </inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ title }}
      </h1>
    </div>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-4xl">
      <form @submit.prevent="submit">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            v-model="form.title"
            :error="form.errors.title"
            class="pr-6 pb-8 w-full"
            label="Judul"
            required />
          <select-input
            v-model="form.portal_status"
            :error="form.errors.portal_status"
            class="pr-6 pb-8 w-full md:w-1/4"
            label="Status Portal"
            required>
            <option value="open">
              Open
            </option>
            <option value="closed">
              Closed
            </option>
          </select-input>
          <div class="pr-6 pb-8 w-full md:w-1/4 flex items-center pt-6">
            <label class="flex items-center">
              <input
                v-model="form.is_active"
                type="checkbox"
                class="form-checkbox">
              <span class="ml-2">Aktif</span>
            </label>
          </div>
          <text-input
            v-model="form.scheduled_open_at"
            v-mask="'##/##/#### ##:##:##'"
            :error="form.errors.scheduled_open_at"
            class="pr-6 pb-8 w-full md:w-1/4"
            input-class="text-center"
            label="Jadwal Buka (Opsional)"
            placeholder="dd/mm/yyyy HH:mm:ss" />
          <text-input
            v-model="form.scheduled_close_at"
            v-mask="'##/##/#### ##:##:##'"
            :error="form.errors.scheduled_close_at"
            class="pr-6 pb-8 w-full md:w-1/4"
            input-class="text-center"
            label="Jadwal Tutup (Opsional)"
            placeholder="dd/mm/yyyy HH:mm:ss" />
          <div class="pr-6 pb-8 w-full">
            <label class="form-label">Konten</label>
            <SimpleEditor v-model="form.content" class="mt-1" />
            <div v-if="form.errors.content" class="form-error">
              {{ form.errors.content }}
            </div>
          </div>
        </div>
        <div
          class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex flex-wrap items-center justify-end space-x-3">
          <button
            type="button"
            @click="handlePreview"
            class="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
            Preview
          </button>
          <button
            type="button"
            @click="handleCancel"
            class="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
            Batal
          </button>
          <loading-button
            :loading="form.processing"
            class="btn-indigo"
            type="submit">
            Simpan Perubahan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Head } from '@inertiajs/vue2'
import { Link, useForm } from '@inertiajs/vue2'
import { format, parseISO } from 'date-fns'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import SimpleEditor from '@/Shared/SimpleEditor'

export default {
  components: {
    Head,
    'inertia-link': Link,
    TextInput,
    SelectInput,
    LoadingButton,
    SimpleEditor,
  },

  props: {
    announcement: Object,
  },

  layout: Layout,

  data () {
    return {
      title: 'Edit Pengumuman',
      form: useForm({
        title: this.announcement.title,
        content: this.announcement.content,
        portal_status: this.announcement.portal_status,
        is_active: this.announcement.is_active,
        scheduled_open_at: this.formatDisplayDate(
          this.announcement.scheduled_open_at,
        ),
        scheduled_close_at: this.formatDisplayDate(
          this.announcement.scheduled_close_at,
        ),
      }),
    }
  },

  methods: {
    formatDisplayDate (date) {
      if (!date) return null
      return format(parseISO(date), 'dd/MM/yyyy HH:mm:ss')
    },
    submit () {
      this.form.put(
        this.route('admin.portal-announcements.update', this.announcement.id),
      )
    },
    handleCancel () {
      this.$inertia.visit(this.route('admin.portal-announcements.index'))
    },
    async handlePreview () {
      try {
        const response = await axios.get(
          `/admin/portal-announcements/${this.announcement.id}/preview-token`,
        )
        const token = response.data.token
        const url = this.route('admin.portal-announcements.preview', {
          id: this.announcement.id,
          token,
        })
        window.open(url, '_blank')
      } catch (error) {
        console.error('Failed to generate preview token:', error)
        alert('Gagal membuat preview token. Silakan coba lagi.')
      }
    },
  },
}
</script>
